import React, { forwardRef } from "react";

import { BadgeProps } from "./Badge.types";
import { BadgeDot, BadgeWrapper } from "./Badge.styles";
import Typography from "../Typography";

const Badge = forwardRef<HTMLDivElement, BadgeProps>(
    (props: BadgeProps, ref) => {
        const {
            text,
            id,
            onClick,
            type = "default",
            showDot = false,
            borderRadius,
            fillType = "contained",
            transparent,
            underline = false,
            fontSize,
            mFontSize,
            leftNode = null,
        } = props;

        return (
            <BadgeWrapper
                onClick={onClick}
                type={type}
                id={id}
                borderRadius={borderRadius}
                fillType={fillType}
                transparent={transparent}
            >
                {showDot ? <BadgeDot /> : null}
                {leftNode}
                <Typography
                    weight="medium"
                    size={fontSize || "s"}
                    mSize={mFontSize || "xs"}
                    align="center"
                    noWrap
                    underline={underline}
                >
                    {text}
                </Typography>
            </BadgeWrapper>
        );
    },
);

export default Badge;
